export default {
    NO_DATA_TEXT: "Здесь пока нет проектов"
};
